import {Tag as PeacockTag} from 'pepsico-ds'
import {TAG_COLOR} from '@/utils/constants/colors'
import {SIZE} from '@/utils/constants/globalStyle'
/**
 * Tag component renders a tag with specified properties.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.text - The text to be displayed inside the tag.
 * @param {boolean} [props.isRemovable=false] - Whether the tag is removable; default is false.
 * @param {boolean} props.isCopyable - Whether the text is copyable; default is false.
 * @param {('Cyan-500'|'Cyan-700'|'Gray-100'|'Gray-500'|'Green-150'|'Green-600'|'Orange-150'|'Orange-400'|'Red-150'|'Red-600'|'Yellow-150'|'Yellow-400'|'Auxiliary-300'|'Auxiliary-600')} [props.color='Auxiliary-600'] props.color - The color class name for the tag.
 * @param {string} [props.id=''] - Optional additional id to apply to the tag.
 * @param {Function} [props.onRemove] - Function to handle remove events.
 * @param {string} [props.size=SIZE.LARGE] - The size of the tag.
 * @param {Function} [props.onClick] - Function to handle click events.
 * @returns {JSX.Element} The rendered Tag component.
 */

const Tag = ({
  text, 
  isRemovable = false,
  isCopyable = false, 
  color = TAG_COLOR.AUXILIARY_600, 
  onRemove = () => {},
  id,
  size = SIZE.LARGE,
  onClick = () => {},
}) => {
  return (
    <span onClick={onClick} style={{cursor: 'pointer'}}>
      <PeacockTag 
        id={`tag` + (id ? `_${id}` : '')}
        data-testid={`tag` + (id ? `_${id}` : '')}
        text={text} 
        isCopyable={isCopyable} 
        color={color} 
        isRemovable={isRemovable}
        onRemove={onRemove}
        size={size}
      />
    </span>
  )
}

export default Tag
